/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} News_LatestInputs */



/**
* | output |
* | --- |
* | "{date} · Latest" |
*
* @param {News_LatestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const news_latest = /** @type {((inputs: News_LatestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<News_LatestInputs, { locale?: "en" | "zh" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ (`${i?.date} · 最新`)
	return /** @type {LocalizedString} */ (`${i?.date} · Latest`)
});